import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Divider } from "@mui/material";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import CommodityIcon from "../../../../assets/icons/CommodityIcon";
import WeightIcon from "../../../../assets/icons/WeightIcon";
import InlineIconButton from "../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../StyledTooltip/StyledTooltip";
import CarrierOffersModalOffers from "./CarrierOffersModalOffers/CarrierOffersModalOffers";
import CarrierOffersModalComments from "./CarrierOffersModalComments/CarrierOffersModalComments";
import CarrierOffersModalTargetPay from "./CarrierOffersModalTargetPay/CarrierOffersModalTargetPay";
import { formatCurrency, formatNumberWithCommas, formatTitleCase } from "../../../../utils/formatHelpers";

export default function CarrierOffersModalSidebar({
  displaySidebar,
  displayMiniSidebar,
  sidebarBG,
  handleDisplaySidebar,
  load,
  offers,
  comments,
  originDate,
  destinationDate,
  handleTableAction
}) {
  return (
    <Box>
      <Box sx={{ margin: "10px", display: "flex", flexDirection: "column", backgroundColor: sidebarBG }}>
        {displaySidebar === "block" &&
          <StyledTooltip title="Collapse">
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <InlineIconButton
                onClick={handleDisplaySidebar}
                icon={KeyboardDoubleArrowLeftIcon}
                buttonColor="grey"
              />
            </Box>
          </StyledTooltip>
        }
        {displayMiniSidebar === "block" &&
          <StyledTooltip title="Expand">
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginY: "15px" }}>
              <InlineIconButton
                onClick={handleDisplaySidebar}
                icon={KeyboardDoubleArrowRightIcon}
                buttonColor="grey"
              />
            </Box>
          </StyledTooltip>
        }
        <Box sx={{ margin: "10px", width: "700px", display: displaySidebar }}>
          <CarrierOffersModalOffers offers={offers} handleTableAction={handleTableAction} />
          <CarrierOffersModalComments comments={comments} />
          {load && <CarrierOffersModalTargetPay activeLoad={load} />}
        </Box>
        <Box sx={{ paddingX: "10px", display: displayMiniSidebar }}>
          <Divider sx={{ marginBottom: "15px" }} />
          <Typography variant="body1" marginBottom="15px" color="black_solid.60">
            <b>Pick Up</b><br />
            {originDate}
          </Typography>
          <Typography variant="body1" marginBottom="15px" color="black_solid.60">
            <b>Drop Off</b><br />
            {destinationDate}
          </Typography>
          <Typography variant="body1" marginBottom="15px" color="black_solid.60">
            <b>Target pay</b><br />
            {formatCurrency(load.targetPay)}
          </Typography>
          <Typography variant="body1" marginBottom="15px" color="black_solid.60">
            <b>Max pay</b><br />
            {formatCurrency(load.maxPay)}
          </Typography>
          <Divider sx={{ marginBottom: "15px" }} />
          <Typography variant="body1" marginBottom="15px" color="black_solid.60">
            <LocalShippingIcon sx={{ fontSize: "15px" }} /><br />
            {load.equipmentTypeId !== null ? `${load.revenueCodeId} ( ${load.equipmentTypeId} )` : load.revenueCodeId}
          </Typography>
          {typeof (load.minTemp) == "number" &&
            <Typography variant="body1" marginBottom="15px" color="black_solid.60">
              Min/Max Temp <br />
              {load.minTemp} /
              {load.maxTemp}
            </Typography>
          }
          <Typography variant="body1" marginBottom="15px" color="black_solid.60">
            <CommodityIcon sx={{ fontSize: "20px", marginBottom: "-10px" }} /><br />
            {formatTitleCase(load.commodity)}
          </Typography>
          <Typography variant="body1" marginBottom="15px" color="black_solid.60">
            <WeightIcon sx={{ fontSize: "15px" }} /><br />
            {formatNumberWithCommas(load.weight)} lbs
          </Typography>
          <Typography variant="body1" marginBottom="15px" color="black_solid.60">
            <SubdirectoryArrowRightIcon sx={{ fontSize: "15px" }} /><br />
            {load.miles} mi
          </Typography>
          {load.orderTypeId &&
            <Typography variant="body1" marginBottom="15px" color="black_solid.60">
              <b>TYPE</b> {load.orderTypeId}
            </Typography>
          }
          <Divider sx={{ marginBottom: "15px" }} />
          <Typography variant="body1" marginBottom="15px" color="black_solid.60">
            <b>Customer charge</b><br />
            <span style={{ display: "flex" }}>
              {formatCurrency(load.total_charge)}
            </span>
          </Typography>
          {offers.length > 0 &&
            <Typography variant="body1" marginBottom="15px" color="black_solid.60">
              <b>Recent Offers</b><br />
              <Box style={{ display: "flex" }}>
                {offers.length} <Typography variant="body1" onClick={handleDisplaySidebar} sx={{ color: "primary.60", marginLeft: "10px", cursor: "pointer" }}>View</Typography>
              </Box>
            </Typography>
          }
          {comments.length > 0 &&
            <Typography variant="body1" marginBottom="15px" color="black_solid.60">
              <b>Rate Con Comments</b><br />
              <Box style={{ display: "flex" }}>
                {comments.length} <Typography variant="body1" onClick={handleDisplaySidebar} sx={{ color: "primary.60", marginLeft: "10px", cursor: "pointer" }}>View</Typography>
              </Box>
            </Typography>
          }
        </Box>
      </Box>
    </Box>
  );
}

CarrierOffersModalSidebar.propTypes = {
  displaySidebar: PropTypes.string,
  displayMiniSidebar: PropTypes.string,
  handleDisplaySidebar: PropTypes.func,
  sidebarBG: PropTypes.string,
  load: PropTypes.object.isRequired,
  offers: PropTypes.array.isRequired,
  comments: PropTypes.array.isRequired,
  originDate: PropTypes.string,
  destinationDate: PropTypes.string,
  handleTableAction: PropTypes.func
};